import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../Icon';
import classNames from 'classnames';
import { forwardRef } from 'react';
export const SearchInput = forwardRef(({ dataTestId, placeholder = 'Search...', size, errors, className, id, onFocus, onClickPostIcon, postIcon, ...rest }, ref) => {
    const handleFocus = (event) => {
        onFocus && onFocus(event);
        if (event.target.value.length) {
            setTimeout(() => event.target.select(), 50);
        }
    };
    const inputWrapperClassName = classNames('flex items-center relative w-full', className);
    const inputClassName = classNames('rounded-full w-full outline-none ring-1 border-none disabled:ring-transparent disabled:bg-gray-200', {
        'text-mBase md:text-base py-[13px] md:py-[9px] pl-[52px] md:pl-10': !size,
        'text-sm py-[7.5px] pl-8': size === 'sm',
        'text-base py-[9px] pl-10': size === 'md',
        'text-mBase py-[13px] pl-[52px]': size === 'lg'
    }, postIcon
        ? {
            'pr-[52px] md:pr-10': !size,
            'pr-8': size === 'sm',
            'pr-10': size === 'md',
            'pr-[52px]': size === 'lg'
        }
        : {
            'pr-5 md:pr-4': !size,
            'pr-3': size === 'sm',
            'pr-4': size === 'md',
            'pr-5': size === 'lg'
        }, !errors ? 'ring-gray-400 focus:ring-2 focus:ring-blue' : 'ring-2 ring-red');
    const iconClassName = classNames('absolute inset-y-0 my-auto text-gray', {
        'h-6 md:h-5 w-6 md:w-5': !size,
        'h-4 w-4': size === 'sm',
        'h-5 w-5': size === 'md',
        'h-6 w-6': size === 'lg'
    });
    const searchIconClassName = classNames(iconClassName, {
        'left-5 md:left-4': !size,
        'left-3': size === 'sm',
        'left-4': size === 'md',
        'left-5': size === 'lg'
    });
    const postIconClassName = classNames(iconClassName, {
        'right-5 md:right-4': !size,
        'right-3': size === 'sm',
        'right-4': size === 'md',
        'right-5': size === 'lg'
    });
    const postIconButtonClassName = classNames({ 'pointer-events-none': !onClickPostIcon });
    return (_jsxs("label", { className: inputWrapperClassName, htmlFor: id, children: [_jsx(Icon, { className: searchIconClassName, name: "search" }), _jsx("input", { autoComplete: "off", className: inputClassName, "data-testid": dataTestId, placeholder: placeholder, ref: ref, onFocus: handleFocus, ...rest }), postIcon && (_jsx("button", { className: postIconButtonClassName, onClick: onClickPostIcon, children: _jsx(Icon, { className: postIconClassName, name: postIcon }) }))] }));
});
